import React from 'react';
import Button from '@common/button';
import Image from '@common/image';
import Text from '@common/text';
import { FontStyle } from '@domain/constant/fontStyle';
import Colors from '@domain/constant/colors';
import classnames from 'classnames/bind';
import styles from './index.module.scss';

const cx = classnames.bind(styles);

interface EmptyContentsProps {
  onClose: () => void;
}

const EmptyContents = ({ onClose }: EmptyContentsProps) => {
  return (
    <div className={cx('area')}>
      <Image
        className={cx('img')}
        src={'/img/v2/components/profile/nhisCareerModal/imgJoy.png'}
        alt={'joy'}
        width={160}
        height={160}
      />

      <Text fontStyle={FontStyle.H5_B} color={Colors.C_COOL_GRAY_90}>
        불러올 수 있는 경력 정보가 없어요.
        <br />
        직접 추가해보시겠어요?
      </Text>

      <Button className={cx('btn')} type={'button'} disabled={false} onClick={onClose}>
        다시 시도하기
      </Button>
    </div>
  );
};

export default EmptyContents;
